import { config } from "config";
import { FC } from "react";

import { Edit, OpenInNew } from "@livechat/design-system-icons";
import {
  ActionMenu,
  ActionMenuItem,
  Avatar,
  Button,
  DesignToken,
  Icon,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  avatar: string | null;
  agentName: string;
  isSelfManagement: boolean;
}

export const AgentDetailsProfileAvatar: FC<IProps> = ({ avatar, agentName, isSelfManagement }) => (
  <Flex
    borderRadius="50%"
    justifyContent="flex-end"
    alignItems="flex-end"
    css={{ position: "absolute", top: "20px", left: "calc(50% + 20px)" }}
  >
    <Flex
      width="100px"
      height="100px"
      bg={withVar(DesignToken.BorderBasicSecondary)}
      borderRadius="50%"
      css={{
        position: "absolute",
        bottom: isSelfManagement ? "-6px" : "-32px",
        right: isSelfManagement ? "-6px" : "-30px",
      }}
    />
    <Avatar
      type={avatar ? "image" : "text"}
      size="xxxlarge"
      src={avatar ?? undefined}
      text={agentName}
      css={{
        position: "absolute",
        bottom: isSelfManagement ? "-4px" : "-30px",
        right: isSelfManagement ? "-4px" : "-28px",
      }}
    />
    {isSelfManagement && (
      <ActionMenu
        placement="bottom-start"
        triggerRenderer={<Button kind="float" size="xcompact" icon={<Icon source={Edit} />} />}
        options={[
          {
            key: "change-avatar",
            element: (
              <ActionMenuItem rightNode={<Icon source={OpenInNew} />}>
                <Text css={{ whiteSpace: "nowrap" }}>Edit picture in Text Accounts</Text>
              </ActionMenuItem>
            ),
            onClick: () => window.open(`${config.textAccountsPanel}/me`),
          },
        ]}
      />
    )}
  </Flex>
);
